
import {PaymentPage} from "../pages/PPayment"

export const Payment =()=>{
	return (<>
	<PaymentPage/>
	</>)
}